class StringConst {
    static get CorporateLabel() { return "Corporate"; }
    static get CounterpartyLabel() { return "Counterparty"; }
    static get UserLabel() { return "User"; }
    static get SECTION_TYPE_PREDIFINED() { return 'PREDEFINED'; }
    static get SECTION_TYPE_FINANCIAL() { return 'FINANCIAL'; }
    static get SECTION_TYPE_DATA() { return 'DATA'; }
    static get SECTION_TYPE_SYSTEMDEFINED() { return 'SYSTEMDEFINED'; }
    static getPageTitle(path) {
        let title = '';
        let loweredPath = path.toLowerCase();
        switch (loweredPath) {
            case '/riskfactor/search': title = 'Search Risk Factors'; break;
            case '/riskfactor/create': title = 'Create Risk Factor'; break;
            case '/riskfactor/list': title = 'Risk Factors List'; break;
            case '/riskfactor/overridingriskfactor/create': title = 'Create Overriding Factor'; break;
            case '/riskfactor/overridingriskfactor/list': title = 'Overriding Factors List'; break;
            
            case '/riskfactor/overridingriskfactor/automated/create': title = 'Create Automated Overriding Factor'; break;
            case '/riskfactor/overridingriskfactor/automated/list': title = 'Automated Overriding Factors List'; break;

            case '/scorecard/search': title = 'Search Scorecards'; break;
            case '/scorecard/create': title = 'Create Scorecard'; break;
            case '/scorecard/list': title = 'Computed Scorecards List'; break;

            case '/case': title = 'View Cases List'; break;
            case '/case/create': title = 'Create Case'; break;

            case '/sectiontemplate/search': title = 'Search Section Templates'; break;
            case '/sectiontemplate/create': title = 'Create Section Template'; break;
            case '/sectiontemplate/list': title = 'Section Templates List'; break;
            //case '/credence/companyid&businessfacts': title = 'Credence'; break;
            case '/international': title = 'International Dashboard'; break;
            case '/early-warning-system': title = 'Early Warning System'; break;
            default: title = 'Rubix';
        }
        if (title === '') {
            if (loweredPath.startsWith('/riskfactor/view')) title = 'View Risk Factor';
            else if (loweredPath.startsWith('/riskfactor/overridingriskfactor/edit')) title = 'Edit Overriding Risk Factor';
            else if (loweredPath.startsWith('/scorecard/edit')) title = 'Edit Scorecard';
            else if (loweredPath.startsWith('/scorecard/view')) title = 'View Scorecard';
            else if (loweredPath.startsWith('/case/view')) title = 'View Case Details';
            else if (loweredPath.startsWith('/sectiontemplate/edit')) title = 'Edit Section Template';
            else if (loweredPath.startsWith('/sectiontemplate/view')) title = 'View Section Template';

        }
        return title;
    }
    static get RequiredLabel() { return "Required" }
}
export default StringConst;